(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JsBundleComponents", [], factory);
	else if(typeof exports === 'object')
		exports["JsBundleComponents"] = factory();
	else
		root["JsBundleComponents"] = factory();
})(this, function() {
return 